import { dispatch, useReframe } from 'nike-re-framejs';
import React, { useEffect } from 'react';

import { formatOdds, formatTicketDetailDate } from '@/common/client';
import i18n from '@i18n';
import { scoreSeparator } from '@/mytickets/utils';
import { SportIcon } from '@/nikeone/components/MiniScoreboardPrematch';
import { ticketDetail$ } from '@/mytickets/detail/subs';

function CashinBet({ bet }) {
    const sportId = bet.get('sportId');
    return (
        <div data-atid="cashin-pick" className="cashin-pick">
            <div className="cashin-bet-opponents">
                <SportIcon sportId={sportId} />
                <span className="home">{bet.getIn(['opponents', 0])}</span>
                <span className="separator">{scoreSeparator(bet)}</span>
                <span className="away">{bet.getIn(['opponents', 1])}</span>
            </div>
            <div data-atid="cashin-tip" className="cashin-tip">
                {bet.get('market')} - {bet.get('pickName')}
                {bet.get('players').size > 0 ? (
                    <span className="c-black-60">
                        :{' '}
                        {bet
                            .get('players')
                            .toArray()
                            .toString()}
                    </span>
                ) : null}
            </div>
            <div data-atid="cashin-odds" className="cashin-odds">
                {formatTicketDetailDate(bet.get('expirationDate'))}
                <span>
                    {i18n('jsp.detailTiketu.kurz')}&nbsp;
                    <b>{formatOdds(bet.get('odds'))}</b>
                </span>
            </div>
        </div>
    );
}

function CashinBetList({ hash }) {
    const derefSub = useReframe();
    useEffect(() => {
        dispatch(['ticketus/detail/fetch', [hash]]);
    }, [hash]);
    const ticket = derefSub(ticketDetail$(hash));
    if (!ticket) {
        return null;
    }
    const bets = ticket.get('bets');
    if (!bets || !bets.size) {
        return null;
    }
    return (
        <div className="cashin-ticket-list">
            {bets.map(bet => (
                <CashinBet bet={bet} key={bet.get('betId')} />
            ))}
        </div>
    );
}

export default CashinBetList;
